(function () {
  let current = null; // { wrap, pop, modal }

  function createBackdrop() {
  let bd = document.querySelector('.pdp-info-backdrop');
  if (!bd) {
    bd = document.createElement('div');
    bd.className = 'pdp-info-backdrop';

    // ✅ Clic sur le fond sombre = fermer
    bd.addEventListener('click', function () {
      closeAll();
    });

    document.body.appendChild(bd);
  }
  return bd;
}

  function removeBackdrop() {
    const bd = document.querySelector('.pdp-info-backdrop');
    if (bd) bd.remove();
  }

  function createModal() {
  let modal = document.querySelector('.pdp-info-modal');
  if (!modal) {
    modal = document.createElement('div');
    modal.className = 'pdp-info-modal';

    // ✅ Clic sur la zone sombre (en dehors de la popup) = fermer
    modal.addEventListener('click', function (e) {
      if (e.target === modal) {
        closeAll();
      }
    });

    document.body.appendChild(modal);
  }
  return modal;
}


  function removeModal() {
    const modal = document.querySelector('.pdp-info-modal');
    if (modal) modal.remove();
  }

  function closeAll() {
    document.body.classList.remove('pdp-info-modal-open');

    // remettre la popup à sa place d’origine
    if (current && current.wrap && current.pop) {
      current.wrap.appendChild(current.pop);
      current.wrap.classList.remove('is-open');

      const btn = current.wrap.querySelector('[data-pdp-info-open]');
      current.pop.setAttribute('aria-hidden', 'true');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }

    current = null;
    removeBackdrop();
    removeModal();
  }

  function open(wrap) {
    const pop = wrap.querySelector('[data-pdp-info-popover]');
    const btn = wrap.querySelector('[data-pdp-info-open]');
    if (!pop || !btn) return;

    closeAll();

    document.body.classList.add('pdp-info-modal-open');

    createBackdrop();
    const modal = createModal();

    // déplacer la popup dans la modal (au niveau body)
    modal.appendChild(pop);

    wrap.classList.add('is-open');
    pop.setAttribute('aria-hidden', 'false');
    btn.setAttribute('aria-expanded', 'true');

    current = { wrap, pop, modal };
  }

  document.addEventListener('click', function (e) {
    const openBtn = e.target.closest('[data-pdp-info-open]');
    const closeBtn = e.target.closest('[data-pdp-info-close]');
    const wrap = e.target.closest('[data-pdp-info-badge]');
    const isBackdrop = e.target.classList && e.target.classList.contains('pdp-info-backdrop');

    if (openBtn && wrap) {
      e.preventDefault();
      open(wrap);
      return;
    }

    if (closeBtn) {
      e.preventDefault();
      closeAll();
      return;
    }

    if (isBackdrop) {
      closeAll();
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });
})();
